/* __next_internal_client_entry_do_not_use__ videoSeekbarProgress,VideoSeekbarProgress auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindVariants } from "@air/tailwind-variants";
import * as RadixProgress from "@radix-ui/react-progress";
export const videoSeekbarProgress = tailwindVariants({
    base: "pointer-events-none h-1 w-full overflow-hidden rounded bg-grey-7",
    variants: {
        color: {
            grey: "text-grey-8",
            teal: "text-teal-9"
        }
    },
    defaultVariants: {
        color: "grey"
    }
});
export const VideoSeekbarProgress = (props)=>{
    const { className, color, percentage, children } = props;
    return /*#__PURE__*/ _jsxs(RadixProgress.Root, {
        className: videoSeekbarProgress({
            className,
            color
        }),
        children: [
            /*#__PURE__*/ _jsx(RadixProgress.Indicator, {
                className: "size-full rounded bg-current",
                style: {
                    transform: "translateX(-".concat(100 - percentage, "%)")
                }
            }),
            children
        ]
    });
};
